import { logoutRedirect } from '@entailor/auth-kit-browser';

import { clearActiveOrg, clearAllSessions } from 'auth/sessionStore';

export default function signOut(): void {
  clearAllSessions();
  clearActiveOrg();
  // The edge clears __Host-Session and ends the platform session.
  logoutRedirect();
}
